import { render, staticRenderFns } from "./QLeadCardDialog.vue?vue&type=template&id=29f06157&"
import script from "./QLeadCardDialog.vue?vue&type=script&lang=js&"
export * from "./QLeadCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./QLeadCardDialog.vue?vue&type=style&index=0&id=29f06157&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports